import { AppState } from 'src/app/shared/models';

import { AppActions, AppActionTypes } from './actions';

export const initialAppState: AppState = {};

export const appReducer = (state = initialAppState, action: AppActions): AppState => {
  switch (action.type) {
    case AppActionTypes.SetDefaultCropYear: {
      return {
        ...state,
        defaultCropYear: action.defaultYear,
      };
    }

    case AppActionTypes.SetAvailableCropYears: {
      return {
        ...state,
        availableCropYears: action.availableCropYears,
      };
    }

    case AppActionTypes.ImportCropYears: {
      return {
        ...state,
        cropYears: action.cropYears,
      };
    }

    case AppActionTypes.SetSearch: {
      return {
        ...state,
        search: action.search,
      };
    }

    case AppActionTypes.SetReportSort: {
      return {
        ...state,
        reportSort: action.reportSort,
      };
    }

    case AppActionTypes.LoadCustomerProgressSuccess: {
      return {
        ...state,
        customerProgress: action.customerProgress,
      };
    }

    case AppActionTypes.LoadAvailableTgaCropsSuccess: {
      return {
        ...state,
        availableTgaCrops: action.availableTgaCrops,
      };
    }
    default: {
      return state;
    }
  }
};
